
$('.form-widget-checkboxinput input:checkbox').change(function() {
    if (this.checked) {
        $(this).parent().find('label').addClass('active');
    } else {
        $(this).parent().find('label').removeClass('active');
    }
});

$('.form-widget-checkboxselectmultiple ul li input:checkbox').change(function() {
    if (this.checked) {
        $(this).parent().addClass('active');
    } else {
        $(this).parent().removeClass('active');
    }
});

$('.form-widget-checkboxinput input:checkbox:checked').parent().find('label').addClass('active');
$('.form-widget-checkboxselectmultiple ul li input:checkbox:checked').parent().addClass('active');

$('.form-widget-radioselect input:radio').click(function() {
    const thisName = $(this).attr('name');

    $(this).parents().eq(2).find('input[name='+thisName+']').parent().removeClass('active');
    $(this).parent().addClass('active');
});

// if ($('input[type="file"]')) {
//     $('.file').append('<span class="file-mask"></span>>')
// }